/*
 * @Author: Chao Yang
 * @Date: 2020-01-22 11:07:41
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-07-01 14:54:38
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as Account from 'src/app/domain/model/account';
import { LayoutProxy } from 'src/app/domain/proxy';
import { RootService } from 'src/app/domain/service/root/index';
import { IInvestmentDetailLayout2023 } from '../../model/dashboard';

@Injectable()
export class LayoutService {
  constructor(
    private _layoutService: LayoutProxy,
    private rootService: RootService
  ) {}

  getAccountDetailConfiguration(
    fundId: number,
    crmAccountId?: number
  ): Observable<Account.IConfiguration> {
    return this._layoutService
      .getAccountDetailConfiguration(
        fundId,
        crmAccountId,
        this.rootService.viewDataForAllInvestors
      )
      .pipe(
        map((configuration) => {
          const sortModules = [];
          configuration.layout
            .sort((l1, l2) => {
              if (l1.Order > l2.Order) {
                return 1;
              } else {
                return -1;
              }
            })
            .forEach((l) => {
              if (configuration.modules.indexOf(l.Module) > -1) {
                sortModules.push(l.Module);
              }
            });
          configuration.modules = sortModules;
          return configuration;
        })
      );
  }

  getAccountDetailLayout2023(
    fundId: number,
    crmAccountId?: number
  ): Observable<IInvestmentDetailLayout2023> {
    return this._layoutService.getAccountDetailLayout2023(
      fundId,
      crmAccountId,
      this.rootService.viewDataForAllInvestors
    );
  }

  updateAccountDetailLayout2023(updateDto: {
    fundId: number[];
    layout: string;
  }) {
    return this._layoutService.updateAccountDetailLayout2023(updateDto);
  }
}
